import React from 'react';

const CsStatsPageTwo = () => {
  return <div>Cs Page Two</div>;
};
export default CsStatsPageTwo;
